export const html = "<p>Eat fresh Sevan trout at &quot;Semoi mot&quot;.</p>\n";
export const leadHtml = "<p>Eat fresh Sevan trout at &quot;Semoi mot&quot;.</p>\n";
export const bodyHtml = "";
export const metaText = "Eat fresh Sevan trout at \"Semoi mot\".";